// Get Query Details Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryEntity } from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class GetQueryDetailsUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(queryId: number, clientView?: boolean): Promise<Result<QueryEntity>> {
    try {
      if (!queryId || queryId <= 0) {
        return Result.fail("Invalid query ID");
      }

      const query = await this.repository.getDetails(queryId, clientView);
      return Result.ok(query);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to fetch query details");
    }
  }
}

